import { Colors } from '@zapier/design-system';
import { css } from '@emotion/core';

const defaultBorder = `1px solid ${Colors.GrayWarm3}`;

const Styles = {
  summary: css`
    display: grid;
    grid-template-columns: auto 75% 1fr;
    grid-gap: 10px 16px;
    padding: 20px;
    list-style: none;
    ::-webkit-details-marker {
      display: none;
    }
    cursor: pointer;
  `,
  arrow: css`
    justify-self: end;
    align-self: center;
    transition: transform 150ms ease;
  `,
  details: css`
    border-top: ${defaultBorder};
    padding: 15px;
    background-color: ${Colors.GrayWarm2};
    display: flex;
    justify-content: space-between;
    align-items: start;
  `,
  todos: css`
    margin-bottom: 0px;
  `,
  todo: css`
    display: flex;
    align-items: center;
  `,
  footer: css`
    padding: 15px 10px;
    border-top: ${defaultBorder};
    border-bottom: none;
    display: grid;
    grid-gap: 10px;
    grid-template-columns: auto auto 1fr;
  `,
};

export default Styles;
